/* JKL OFFROAD - YMM picker behaviour (vehicle type first).
   Moved out of sections/ymm-selector.liquid on 2026-08-20; deferred asset, runs after
   jkl-machine-route-1..5 so the routing table exists before buildFilterUrl().

   2026-09-23 - SNOWMOBILE HIDDEN FROM THE PICKER (owner decision: ATV/UTV focus).
   'W' is removed from TYPE_ORDER, so the Snowmobile option never renders and no
   snowmobile make/model is offered. The fitment JSON and its 'W|' values are
   untouched, so snowmobile machine pages reached from Google still work and a
   saved snowmobile vehicle still shows its chip. Put 'W' back in TYPE_ORDER to reverse. */
(function () {
  'use strict';

  var STORAGE_KEY = 'jkl_selected_vehicle';
  var TYPE_LABEL  = { A: 'ATV', S: 'Side-by-Side / UTV', W: 'Snowmobile' };
  var TYPE_ORDER  = ['A', 'S'];        /* 'W' removed 2026-09-23 */
  var TYPE_KNOWN  = ['A', 'S', 'W'];   /* still parsed so W| values are not mis-read as untyped */
  var OTHER       = '_other';

  var drawer      = document.getElementById('jkl-ymm-drawer');
  var overlay     = document.getElementById('jkl-ymm-overlay');
  var trigger     = document.getElementById('jkl-ymm-trigger');
  var trigLabel   = document.getElementById('jkl-ymm-trigger-label');
  var drawerClose = document.getElementById('jkl-ymm-drawer-close');
  var form        = document.getElementById('jkl-ymm-form');
  var chip        = document.getElementById('jkl-ymm-chip');
  var fieldType   = document.getElementById('jkl-ymm-field-type');
  var selType     = document.getElementById('jkl-ymm-type');
  var selYear     = document.getElementById('jkl-ymm-year');
  var selMake     = document.getElementById('jkl-ymm-make');
  var selModel    = document.getElementById('jkl-ymm-model');
  var btnSubmit   = document.getElementById('jkl-ymm-submit');
  var chipLabel   = document.getElementById('jkl-ymm-chip__label');
  var chipShop    = document.getElementById('jkl-ymm-chip__shop');
  var chipChange  = document.getElementById('jkl-ymm-chip__change');
  var chipClear   = document.getElementById('jkl-ymm-chip__clear');
  var status      = document.getElementById('jkl-ymm-status');

  var MODE     = (drawer.dataset.typeMode || 'all').toLowerCase();
  var TYPE_ON  = MODE !== 'off';
  var pilotSet = {};
  (drawer.dataset.typeMakes || '').split(',').forEach(function (s) {
    s = s.replace(/^\s+|\s+$/g, '');
    if (s) pilotSet[s.toLowerCase()] = 1;
  });
  var PILOT_ON = (MODE === 'pilot') && Object.keys(pilotSet).length > 0;
  function typedMake(make) {
    return !PILOT_ON || Object.prototype.hasOwnProperty.call(pilotSet, String(make).toLowerCase());
  }

  var fitmentData = null;
  var typeIndex   = null;

  function openDrawer() {
    loadFitment();
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    var firstFocusable = drawer.querySelector('button:not([disabled]), select:not([disabled]), [href]');
    if (firstFocusable) setTimeout(function () { firstFocusable.focus(); }, 50);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus();
  }

  function updateTrigger(vehicle) {
    if (vehicle && vehicle.year && vehicle.make) {
      trigLabel.textContent = [vehicle.year, vehicle.model].filter(Boolean).join(' ');
    } else {
      trigLabel.textContent = 'Find My Parts';
    }
  }

  function opt(val, label) {
    var o = document.createElement('option');
    o.value = val;
    o.textContent = label || val;
    return o;
  }

  function resetSelect(sel, placeholder) {
    sel.innerHTML = '';
    sel.appendChild(opt('', placeholder));
    sel.disabled = true;
  }

  function selectValue(sel, val) {
    if (!val) return false;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === val) { sel.value = val; return true; }
    }
    return false;
  }

  function parseRange(rangeStr) {
    var years = [];
    if (!rangeStr) return years;
    rangeStr.split(',').forEach(function (part) {
      var dash = part.indexOf('-');
      if (dash > 0) {
        var from = parseInt(part.slice(0, dash), 10);
        var to   = parseInt(part.slice(dash + 1), 10);
        for (var y = from; y <= to; y++) years.push(String(y));
      } else {
        years.push(part.trim());
      }
    });
    return years;
  }

  function splitValue(v) {
    if (typeof v !== 'string') return { t: null, y: '' };
    if (v.length > 1 && v.charAt(1) === '|' && TYPE_KNOWN.indexOf(v.charAt(0)) > -1) {
      return { t: v.charAt(0), y: v.slice(2) };
    }
    return { t: null, y: v };
  }

  function mergeFitmentData(sources) {
    var merged = {};
    var canonKey = {};
    sources.forEach(function (src) {
      if (!src || !src.data) return;
      Object.keys(src.data).forEach(function (make) {
        var lk = make.toLowerCase();
        var target = canonKey[lk];
        if (!target) { target = make; canonKey[lk] = make; }
        if (!merged[target]) merged[target] = {};
        var models = src.data[make];
        Object.keys(models).forEach(function (model) {
          var rec  = splitValue(models[model]);
          var have = merged[target][model];
          if (have) {
            if (have.y !== rec.y) have.y = have.y + ',' + rec.y;
            if (!have.t) have.t = rec.t;
          } else {
            merged[target][model] = { t: rec.t, y: rec.y };
          }
        });
      });
    });
    return merged;
  }

  function buildTypeIndex(data) {
    var idx = {};
    function put(t, year, make, model) {
      if (!idx[t]) idx[t] = {};
      if (!idx[t][year]) idx[t][year] = {};
      if (!idx[t][year][make]) idx[t][year][make] = [];
      idx[t][year][make].push(model);
    }
    Object.keys(data).forEach(function (make) {
      var models  = data[make];
      var byType  = TYPE_ON && typedMake(make);
      Object.keys(models).forEach(function (model) {
        var rec   = models[model];
        var years = parseRange(rec.y);
        for (var i = 0; i < years.length; i++) {
          var year = years[i];
          if (!byType) { put(OTHER, year, make, model); continue; }
          if (rec.t) { put(rec.t, year, make, model); continue; }
          for (var j = 0; j < TYPE_ORDER.length; j++) put(TYPE_ORDER[j], year, make, model);
        }
      });
    });
    Object.keys(idx).forEach(function (t) {
      Object.keys(idx[t]).forEach(function (y) {
        Object.keys(idx[t][y]).forEach(function (m) {
          var list = idx[t][y][m].sort(), out = [];
          for (var i = 0; i < list.length; i++) if (list[i] !== list[i - 1]) out.push(list[i]);
          idx[t][y][m] = out;
        });
      });
    });
    return idx;
  }

  function currentType() { return TYPE_ON ? selType.value : OTHER; }

  function populateTypes() {
    if (!typeIndex) return;
    if (!TYPE_ON) { populateYears(); return; }
    resetSelect(selType, 'Select Vehicle Type');
    TYPE_ORDER.forEach(function (t) {
      if (typeIndex[t]) selType.appendChild(opt(t, TYPE_LABEL[t]));
    });
    if (typeIndex[OTHER]) selType.appendChild(opt(OTHER, 'Other makes'));
    selType.disabled = false;
    resetSelect(selYear,  'Select Year');
    resetSelect(selMake,  'Select Make');
    resetSelect(selModel, 'Select Model');
    btnSubmit.disabled = true;
  }

  function populateYears() {
    if (!typeIndex) return;
    resetSelect(selYear,  'Select Year');
    resetSelect(selMake,  'Select Make');
    resetSelect(selModel, 'Select Model');
    btnSubmit.disabled = true;
    var t = currentType();
    if (!t || !typeIndex[t]) return;
    Object.keys(typeIndex[t]).sort(function (a, b) { return b - a; }).forEach(function (y) {
      selYear.appendChild(opt(y));
    });
    selYear.disabled = false;
  }

  function onTypeChange() { populateYears(); }

  function onYearChange() {
    resetSelect(selMake,  'Select Make');
    resetSelect(selModel, 'Select Model');
    btnSubmit.disabled = true;
    var t = currentType(), y = selYear.value;
    if (!t || !y || !typeIndex[t] || !typeIndex[t][y]) return;
    Object.keys(typeIndex[t][y]).sort().forEach(function (m) { selMake.appendChild(opt(m)); });
    selMake.disabled = false;
  }

  function onMakeChange() {
    resetSelect(selModel, 'Select Model');
    btnSubmit.disabled = true;
    var t = currentType(), y = selYear.value, m = selMake.value;
    if (!t || !y || !m) return;
    var models = (typeIndex[t] && typeIndex[t][y] && typeIndex[t][y][m]) || [];
    models.forEach(function (mdl) { selModel.appendChild(opt(mdl)); });
    selModel.disabled = (models.length === 0);
    if (models.length === 0) btnSubmit.disabled = false;
  }

  function onModelChange() { btnSubmit.disabled = !(selYear.value && selMake.value); }

  var COLLECTION_BY_MAKE = {
    'Polaris':          '/collections/polaris-1',
    'Yamaha':           '/collections/yamaha-1',
    'Honda':            '/collections/honda-1',
    'Can-Am':           '/collections/can-am-1',
    'Kawasaki':         '/collections/kawasaki-1',
    'Arctic Cat':       '/collections/arctic-cat',
    'Suzuki':           '/collections/suzuki-1',
    'CFMOTO':           '/collections/cf-moto-1',
    'Segway':           '/collections/segway',
    'Ski-Doo':          '/collections/ski-doo',
    'Bombardier':       '/collections/bombardier',
    'Speed UTV':        '/collections/speed-utv',
    'HISUN':            '/collections/hisun',
    'Kubota':           '/collections/kubota',
    'Kymco':            '/collections/kymco',
    'John Deere':       '/collections/john-deere',
    'Tracker Off Road': '/collections/tracker-off-road',
    'Intimidator':      '/collections/intimidator',
    'Massimo':          '/collections/massimo',
    'Mahindra':         '/collections/mahindra',
    'New Holland':      '/collections/new-holland',
    'Cub Cadet':        '/collections/cub-cadet',
    'Bad Boy':          '/collections/bad-boy',
    'Bison':            '/collections/bison',
    'Joyner':           '/collections/joyner',
    'Tuatara':          '/collections/tuatara',
    'Coleman':          '/collections/coleman',
    'TGB':              '/collections/tgb',
    'Argo':             '/collections/argo'
  };
  var COLLECTION_BY_MAKE_LC = {};
  Object.keys(COLLECTION_BY_MAKE).forEach(function (k) { COLLECTION_BY_MAKE_LC[k.toLowerCase()] = COLLECTION_BY_MAKE[k]; });
  function collectionForMake(make) {
    if (!make) return null;
    return COLLECTION_BY_MAKE_LC[String(make).toLowerCase()] || null;
  }

  function buildFilterUrl(make, model, year) {
    if (typeof window.JKL_MACHINE_ROUTE === 'function') {
      var machine = window.JKL_MACHINE_ROUTE(make, model);
      if (machine) return machine;
    }
    var base = collectionForMake(make) || '/collections/all';
    if (String(make).toLowerCase() === 'polaris' && typeof window.JKL_POLARIS_ROUTE === 'function') {
      base = window.JKL_POLARIS_ROUTE(model, year) || base;
    }
    var params = [];
    if (model) params.push('filter.p.m.custom.model=' + encodeURIComponent(model));
    if (year)  params.push('filter.p.m.custom.year='  + encodeURIComponent(year));
    return params.length ? base + '?' + params.join('&') : base;
  }

  function showChip(vehicle) {
    chipLabel.textContent = [vehicle.year, vehicle.model].filter(Boolean).join(' ');
    chipShop.href = buildFilterUrl(vehicle.make, vehicle.model, vehicle.year);
    form.hidden = true;
    chip.hidden = false;
  }

  function saveVehicle(type, year, make, model) {
    var vehicle = { type: type || null, year: year, make: make, model: model, savedAt: Date.now() };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle)); } catch (e) {}
    showChip(vehicle);
    updateTrigger(vehicle);
    document.dispatchEvent(new CustomEvent('jkl:vehicleSaved', { detail: vehicle }));
    return vehicle;
  }

  function clearVehicle() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    form.hidden = false;
    chip.hidden = true;
    resetSelect(selYear,  'Select Year');
    resetSelect(selMake,  'Select Make');
    resetSelect(selModel, 'Select Model');
    btnSubmit.disabled = true;
    updateTrigger(null);
    loadFitment().then(function () { populateTypes(); });
    document.dispatchEvent(new CustomEvent('jkl:vehicleCleared'));
  }

  function onSubmit(e) {
    e.preventDefault();
    var year  = selYear.value, make = selMake.value, model = selModel.value;
    if (!year || !make) return;
    saveVehicle(currentType(), year, make, model);
    window.location.href = buildFilterUrl(make, model, year);
  }

  var savedVehicle = null;

  function inferType(make, model) {
    if (!TYPE_ON) return OTHER;
    if (!fitmentData || !make) return null;
    if (!typedMake(make)) return OTHER;
    var models = fitmentData[make];
    if (!models) return null;
    var rec = models[model];
    if (rec && rec.t) return rec.t;
    return null;
  }

  function preselect(v) {
    populateTypes();
    if (!v) return;
    if (TYPE_ON) {
      var t = v.type;
      if (!t || !selectValue(selType, t)) {
        t = inferType(v.make, v.model);
        if (!t || !selectValue(selType, t)) return;
      }
      onTypeChange();
    } else {
      populateYears();
    }
    if (!selectValue(selYear, v.year)) return;
    onYearChange();
    if (!selectValue(selMake, v.make)) return;
    onMakeChange();
    if (selectValue(selModel, v.model)) onModelChange();
  }

  function restoreVehicle() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var v = JSON.parse(raw);
      if (v && v.year && v.make) {
        savedVehicle = v;
        showChip(v);
        updateTrigger(v);
        return true;
      }
    } catch (e) {}
    return false;
  }

  var dataPromise = null;
  function loadFitment() {
    if (dataPromise) return dataPromise;
    var urlA = drawer.dataset.fitmentUrlA, urlB = drawer.dataset.fitmentUrlB, urlC = drawer.dataset.fitmentUrlC;
    status.textContent = 'Loading…';
    function getJson(u) {
      if (!u) return Promise.resolve({ data: {} });
      return fetch(u).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }).catch(function () { return { data: {} }; });
    }
    dataPromise = Promise.all([ getJson(urlA), getJson(urlB), getJson(urlC) ])
      .then(function (results) {
        fitmentData = mergeFitmentData(results);
        typeIndex   = buildTypeIndex(fitmentData);
        var hasData = typeIndex && Object.keys(typeIndex).length > 0;
        if (!hasData) {
          dataPromise = null;
          status.textContent = 'Could not load fitment data — please refresh, or call/text 385-430-5221 for fitment help.';
          return false;
        }
        status.textContent = '';
        if (chip.hidden) populateTypes();
        return true;
      })
      .catch(function () {
        dataPromise = null;
        status.textContent = 'Could not load fitment data — please refresh, or call/text 385-430-5221 for fitment help.';
        return false;
      });
    return dataPromise;
  }

  function boot() { restoreVehicle(); }

  trigger.addEventListener('click',     openDrawer);
  drawerClose.addEventListener('click', closeDrawer);
  overlay.addEventListener('click',     closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  selType.addEventListener('change',  onTypeChange);
  selYear.addEventListener('change',  onYearChange);
  selMake.addEventListener('change',  onMakeChange);
  selModel.addEventListener('change', onModelChange);
  form.addEventListener('submit',     onSubmit);
  chipChange.addEventListener('click', function () { form.hidden = false; chip.hidden = true; loadFitment().then(function () { preselect(savedVehicle); }); });
  chipClear.addEventListener('click', clearVehicle);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();